
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { useAnimationSimplifier } from "@/hooks/use-animation-simplifier";

interface CircleDecorProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'accent';
  animated?: boolean;
}

export const CircleDecor = ({ className, size = 'md', variant = 'primary', animated = false }: CircleDecorProps) => {
  const { shouldSimplifyAnimations, animationDuration } = useAnimationSimplifier();
  
  const sizeClasses = {
    sm: 'h-16 w-16',
    md: 'h-24 w-24',
    lg: 'h-32 w-32',
  };
  
  const variantClasses = {
    primary: 'bg-gradient-to-br from-brand-primary to-brand-secondary',
    secondary: 'bg-gradient-to-br from-brand-secondary to-brand-accent',
    accent: 'bg-gradient-to-br from-brand-accent to-brand-secondary',
  };
  
  return (
    <motion.div 
      className={cn(
        "rounded-full", 
        sizeClasses[size], 
        variantClasses[variant],
        className
      )}
      animate={animated && !shouldSimplifyAnimations ? {
        y: [0, -10, 0],
        scale: [1, 1.05, 1],
        rotate: [0, 5, 0, -5, 0],
      } : undefined}
      transition={animated && !shouldSimplifyAnimations ? {
        duration: animationDuration * 5,
        repeat: Infinity,
        ease: "easeInOut"
      } : undefined}
    />
  );
};
